import { useEffect } from 'react';
import { Modal } from 'react-bootstrap';

function FailureIcon() {
  return (
    <svg width="62" height="62" viewBox="0 0 86 86" fill="none" aria-hidden="true">
      <circle cx="43" cy="43" r="31.875" fill="#F287B7" />
      <path d="M32 32L54 54" stroke="white" strokeWidth="6" strokeLinecap="round" />
      <path d="M54 32L32 54" stroke="white" strokeWidth="6" strokeLinecap="round" />
    </svg>
  );
}

function FailureScanModal({ show, message, onHide }) {
  useEffect(() => {
    if (!show) return undefined;
    const timer = window.setTimeout(() => onHide?.(), 5000);
    return () => window.clearTimeout(timer);
  }, [onHide, show]);

  return (
    <Modal show={show} onHide={onHide} centered className="scanResultModal">
      <Modal.Body>
        <FailureIcon />
        <div className="loaderTxtScan">{message}</div>
      </Modal.Body>
    </Modal>
  );
}

export default FailureScanModal;
